import { createElementIdSlice } from '../utils/action/createElementSlice';
export const ImageState = createElementIdSlice({
    elementName: 'image',
    initialState: {},
    reducers: {
        notifyClick: (state, _action) => state,
    },
});
